import { UIComponentState, UIComponentHandler, UIDataModel, UIComponentProps, UIComponentImpl } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { TuneSettingsViewImpl } from './tunesettingsview';
import { TuneSettingsCSSStyleImpl } from './tunesettingscss';
import { TuneSettingsAPIModelImpl, TuneSettingsAPIModel } from './tunesettingsapimodel';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { GroupDto } from '../../../../core/dto/listtones/groupdto';
import { Strings } from '../../../../utils/resources/strings';
import { ToneDto, ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { DefaultToneDtoImpl} from '../../../../core/dto/deafulttone/defaulttonedto';
import { ListTonesComponent } from '../listtone/listtonecomponent';

// import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface TuneSettingsComponentProps extends UIComponentProps
{  
    toneDto: ToneDto;
    isShuffleOn:boolean;

   onSettingsSuccess(): void;
   onCancelClicked(): void;
}

export interface TuneSettingsComponentState extends UIComponentState
{
   toneDto: ToneDto;
   isAddToShuffle:boolean;
}

export interface TuneSettingsComponentHandler extends UIComponentHandler
{
    onConfirmedClicked(): void;
    onCancelClicked(): void;
    isShuffleOn(isEnabled:boolean, toneDto:ToneDto):any;
    showShufflePopup():void;
    addToShuflleSelected(onSelected:boolean):void;
}

export class TuneSettingsComponent extends UIComponentImpl<TuneSettingsComponentProps, TuneSettingsComponentState, UIDataModel> implements TuneSettingsComponentHandler
{
    listToneComponent:ListTonesComponent;
    constructor(props: TuneSettingsComponentProps)
    {
        super(props);

        this.state = {toneDto: this.props.toneDto,isAddToShuffle:false};
    }

    componentDidMount()
    {
        // (this.getView() as TuneSettingsViewImpl).showLoader();
        // (this.getAPIModel() as TuneSettingsAPIModel).getGroups();
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TuneSettingsViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TuneSettingsCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new TuneSettingsAPIModelImpl(applicationContext, apiModelHandler);
    }
    
    UNSAFE_componentWillReceiveProps(nextProps: TuneSettingsComponentProps) 
    {          
        console.log("----UNSAFE_componentWillReceiveProps: " + nextProps.isShuffleOn);
        console.log("----UNSAFE_componentWillReceiveProps from existing: " + this.props.isShuffleOn);
    }

    isShuffleOn(isEnabled:boolean, toneDto:ToneDto): any 
    {
        
        
        if(isEnabled)
        {
            (this.getView() as TuneSettingsViewImpl).showShuffleSuccessPopup();
        }
       
    }

    showShufflePopup():void
    {
        let dto = new DefaultToneDtoImpl();
        dto.setToneId(this.state.toneDto.getId());
        dto.setPackName(this.props.context.getUserContext().getPackName());
        (this.getView() as TuneSettingsViewImpl).closePopup();
        (this.getView() as TuneSettingsViewImpl).showLoader(); 
        (this.getAPIModel() as TuneSettingsAPIModel).defaultToneAPI(dto);
        // this.props.onSettingsSuccess();
        
    }
    onConfirmedClicked(): void 
    {
        let callerSelected = (this.getView() as TuneSettingsViewImpl).getCallerSettingSelected();
        
        if((this.getView() as TuneSettingsViewImpl).validate() && (this.getView() as TuneSettingsViewImpl).validateAllCallers())
        {
            (this.getView() as TuneSettingsViewImpl).showLoader();
            if(callerSelected === this.props.context.getResources().getString(Strings.all_callers))
            {
                (this.getAPIModel() as TuneSettingsAPIModel).getTuneSettingsForAllCaller((this.getView() as TuneSettingsViewImpl).getAllCallerSettingsData());
            } 
            else if(callerSelected === this.props.context.getResources().getString(Strings.callers_group))
            {
                (this.getAPIModel() as TuneSettingsAPIModel).timeBasedSettingForCallersGroupAPI((this.getView() as TuneSettingsViewImpl).getCallerGroupSettingsData());
            } 
            else if(callerSelected === this.props.context.getResources().getString(Strings.add_to_shuffle))
            {
                (this.getAPIModel() as TuneSettingsAPIModel).getTuneSettingsForAllCaller((this.getView() as TuneSettingsViewImpl).getAddToShuffleSettingsData());
            } 
            else
            {
                (this.getAPIModel() as TuneSettingsAPIModel).timeBasedSettingForSpecificCallerAPI((this.getView() as TuneSettingsViewImpl).getSpecialCallerSettingsData());
            } // case for add to shuffle

        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as TuneSettingsViewImpl).dismissLoader();
       if(feature === APIFeatures.LIST_TONES)
       {
           (this.getView() as  TuneSettingsViewImpl).setGroupsData(data as GroupDto[]);
       }
       else if(feature === APIFeatures.SEARCH_TONE)
       {
           this.setState({toneDto: data as ToneDtoImpl});
       }
       else if(feature === APIFeatures.DEFAULT_TONE)
       {
        this.props.onSettingsSuccess();
       }
      else
      {
        // this.props.onSettingsSuccess();

        (this.getView() as TuneSettingsViewImpl).showPopup(this.getContext().getResources().getString(Strings.tune),
        this.getContext().getResources().getString(Strings.your_tune_is_live_now),AlertType.SUCCESS);
      }
    }

    onCancelClicked(): void 
    {
        this.props.onCancelClicked();
        // this.props.routeNextFeature(RoutingFeatures.MYTUNES, false);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as TuneSettingsViewImpl).dismissLoader();
        if(feature !== APIFeatures.LIST_TONES && feature !== APIFeatures.SEARCH_TONE)
       {
           (this.getView() as TuneSettingsViewImpl).showShuffleFailurePopup(this.getContext().getResources().getString(Strings.tune),description,AlertType.ERROR);
       }
   
    }  

    
    addToShuflleSelected(onSelected:boolean)
    {
        this.setState({isAddToShuffle:onSelected});
    }
    componentWillUnmount()
    {
        // this.props.context.setToneContext(null);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/tunesettingscomponent.tsx